<template>
  <div class="maindiv">  
    <div class="textsection">
      <h1>Museum Guide</h1>      
      
      <div class="section howto">
        <h3 class="how-title">If You Read Only One Thing On This Website, Please Read This:</h3><br>
        The point of Rockcliff Museum is to showcase not the items, but the names of the people who made this
        world. This Museum is about all of you. Each item is renamed with the name of the person who created
        it. Please do not right-click examine the items when visiting. Every time an item is examined, there is a
        chance the signature will fade forever, and yours will replace it. I want to avoid that scenario as much as
        I can, so please keep actual examination to a minimum. For a more detailed explanation of this, please
        read The Preservation Process page in full. Thank you!
      </div>
            &nbsp;<br>
      <div class="center-box"> 
        <h3 class="section-title">Hours of Operation</h3><br>
          <b>Rockcliff Museum is open to the public 24 hours a day, 7 days a week except for 2 days prior to the yearly Gala in Sept.</b>
      </div> 

      <div class="center-box">
        <img class="enterimage" src="../assets/new entrance.png" alt="North museum entrance at night"><br>
        North Entry Hall and Tich Memorial Bridge
      </div>
            
      <div class="section"> 
        <h3 class="section-title">Rockcliff Museum Building</h3><br>
        The main Museum building has 3 floors. The first floor is full of items found or donated by folks all 
        over the PvE servers in the Southern Freedom Islands. The second floor is full of items found or donated 
        by folks on Chaos, the PvP server, as well as Epic PvPers who came to Freedom to leave their footprint here, 
        too. The third and topmost floor is entirely dedicated to the people that work day and night to make sure 
        we can all be here doing this together. This third floor will always be a place of honoring the Devs and 
        Staff and Gods in Wurm.
      </div> 
            
      <div class="section"> 
        <h3 class="section-title">Observation Tower</h3><br>
        The Observation Tower houses the Room of Anvils, Nalimar's Token display, Dyes by Auntie Sid, and there 
        are other displays on each floor. Access to the Observation Tower is around the side. You will find a ladder 
        up, and every floor except the ground floor of that building is open to all, and each floor has small displays 
        for folks to enjoy. The view at the top is a breathtaking vista of the entire southern half of the Inner Sea 
        as well as a joyful display by Cenotaph. <br>
        <div class="center-box"><img class="small-img" src="../assets/obs tower.png" alt="Observation tower"></div>
      </div>       

      <div class="section"> 
        <h3 class="section-title">Hall of Alliances</h3><br>
        These three pictures are the hall of alliances as viewed from the second floor of the main museum building,
        the first floor with PVE alliance displays, and the second floor PVP kingdom displays.<br>
        The Hall of Alliances was created to showcase various communities in Wurm. Alliances and other community 
        groups are invited to do a one tile display with items that have signatures from their community mates, 
        so everyone can be together in the Hall. This is open to current and past alliances.
        Like the main Museum building, there is a second floor for Kingdoms found on Chaos. Over 20 Kingdoms, past 
        and present, are currently represented in the Hall with displays of items with signatures of players who 
        were/are in those Kingdoms. Nirav and Camaril terraformed an area north of the Museum grounds to build this new 
        building prior to the Gala in 2023. There is still room for more displays. <br>
        If your alliance or kingdom is interested in creating a one tile display and having it installed here, 
        please contact Nirav on the <a href="https://forum.wurmonline.com/index.php?/profile/76620-nirav/">
        Wurm forum</a> or in game.<br>        
        <div class="center-box">
          <img class="small-img" src="../assets/hall of alliances.png" alt="hall of alliances front from a distance"> &nbsp; 
          <img class="small-img" src="../assets/hall of alliances 1st floor.jpg" alt="hall of alliances interior 1st floor"> &nbsp; 
          <img class="small-img" src="../assets/hall of alliances 2nd floor.jpg" alt="hall of alliances interior 2nd floor">
        </div>
      </div> 

      <div class="section"> 
        <h3 class="section-title">NFI Building</h3><br>
        The NFI Building has two floors with two more areas of different height. This building has items from 
        players in NFI, as well as a Brazilian display that was put together by a group that came over to SFI to the 
        Museum specifically to create that display. Both NFI PVE and PVP are represented, though the displays are a 
        bit more mixed than in the Main Building. Most of the PVP items are on the second floor.
      </div> 

      <div class="section"> 
        <h3 class="section-title">Rockcliff Workshop</h3><br>
        Here is where folks from NFI (and anywhere else) can make things to place in the Museum. This is open and 
        staffed during the Gala to help folks with that process. Appointments can be made with Nirav to use the 
        building on the other days of the year for folks who want to put an item in the Museum and can't make it to 
        the Gala.
      </div> 

      <div class="section"> 
        <h3 class="section-title">Rockcliff Temple</h3><br>        
        This building was inspired by the priests who attend the Gala to do sermons. Instead of having them off-deed 
        and away from everything, this gives them a better view of what is happening on the Museum grounds, and will 
        allow them to be more present and involved if they choose to be, without having to leave their sermon area.<br>        
        <div class="center-box"><img class="small-img" src="../assets/temple.png" alt="Temple"></div>
      </div> 

      <div class="section"> 
        <h3 class="section-title">Boozen Haus</h3><br>
        This is a permanent display that is a copy of Reddragon's Bar created to his specifications
      </div> 

      <div class="section"> 
        <h3 class="section-title">Little Zoo</h3><br>
        This area is for GM created animals at the Gala as well as other special creatures.
      </div> 
      
      <div class="section"> 
        <h3 class="section-title">Museum Shop</h3><br>
        This Shop is down at the intersection of FM NW HWY coming from Freedom
        Market, and the Coast Highway that goes along the shore. It is in Lyric Beach which is right down the hill
        next to Rockcliff Museum by the peat bog. At the shop you will find archaeology items, recipe and
        archaeology mob drops from Nirav, leather and cloth items made by Camaril, dyes made by Auntie
        Sidereal, and tools and weapons made by Hvergi.
      </div> 

         

      
      <div class="section"> 
        <h3 class="section-title">Location</h3><br>
        Rockcliff Museum is located down the Freedom Market NW Highway, a rough couple dozen tiles or so 
        from Rockcliff Cathedral, on the E side or the road. It is nestled in a corner of the base of Dragon 
        Fang Mountain, and has a stunning view of the sea and Black Dog Island. It is built upon the lands 
        that Tich settled when Independence opened. It is located at K 15, Independence, SFI. You may portal 
        to The Howl and then run down the FM road to the Museum. Please look at the two diagrams here for more 
        specific location information.<br>
        <img class="standard-size" src="../assets/Museum Location copy.png" alt="albia indy map for website"> 
        <img class="standard-size" src="../assets/Museum Map FP.png" alt="map">
      </div> 
      
      <div class="section"> 
        <h3 class="section-title">Where to Stay</h3><br>
        Fairview Harbor Inn is at the docks down the peat hillside from the museum in Rockcliff Terraces at Fairview. 
        The museum can be seen from this Inn. There are two buildings. Building 1 has 8 rooms, Building 2 has 22 
        rooms, and Building 3 has 30 rooms. All rooms at the Inn are free. During the Gala, it is recommended that you 
        reserve a room. Maple Leaf Inn on the far western edge of Lyric Beach is a guesthouse with 4 free beds that is 
        also always open to the public. It is across from the original Museum site that now houses special items in 
        Nirav's personal collection. There is also a camping area between Rockcliff Museum and Rockcliff Terraces at 
        Fairview where anyone can pitch a tent during the Gala. This camping area is clearly marked, but is small, so 
        get there early if you want to camp.
      </div> 
      
      <div class="section"> 
        <h3 class="section-title">Fees</h3><br>
        Rockcliff Museum is FREE and always will be as long as I have any control over it. If you wish to add coins to the 
        token, you may do so, but that is not at all expected.
      </div>  
      
      <div class="section"> 
        <h3 class="section-title">Surrounding Area</h3><br>
        Fanghenge and the beautiful Rockcliff Cathedral built by Tich are just across the road from Rockcliff Museum, and 
        well worth the time to go see. For the more adventurous, continue south up the NW FM Highway to access Dragon Fang 
        Mountain's Green Ring.
      </div> 
      
      <br> &nbsp; <br> 
    </div>
  </div>  
</template>


<script>
  export default {
    name: 'MuseumGuide',
    methods: {
    }
  }
</script>


<style>
  img {
    margin: 0;
    padding: 0;
  }

  .enterimage {
    width: 90%;
    max-width: 300px;
    border: 2px solid black;
    margin: 30px auto 10px auto;
  }

  .image_special {
  max-width: 380px;
  border: 2px solid black;
  }

</style>